import * as React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { MODAL_STATUS_CANCEL, MODAL_STATUS_CLOSE, MODAL_STATUS_OK } from '../../../constants/modal';
import { isI18NString, ModalInfo, ModalStatus } from '../../../types/modal';
import ModalView from '../ModalView';

interface ConfirmModalProps {
    modal: ModalInfo,
    closeModal: (status: ModalStatus, result: any) => void
}

export default class ConfirmModal extends React.Component<ConfirmModalProps> {

    constructor(props: ConfirmModalProps) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }
    renderTemplate(): React.ReactElement {
        const { body } = this.props.modal.options;

        let message = <></>;
        if (isI18NString(body)) {
            message = <FormattedMessage id={body.id} values={body.values} defaultMessage="Confirm action" />;
        } else if (typeof body === "string") {
            message = <>{body}</>;
        }

        return <div>{message}</div>;
    }


    closeModal(status: ModalStatus, result: any) {
        if (status == MODAL_STATUS_OK) {
            this.props.closeModal(status, true);
        } else if (status == MODAL_STATUS_CANCEL || status == MODAL_STATUS_CLOSE) {
            this.props.closeModal(status, false);
        }
    }

    render() {
        const modal = { ...this.props.modal };
        modal.options = { ...modal.options, title: modal.options.title || { id: "CONFIRM_MODAL_TITLE" } };
        return <ModalView modal={modal} template={this.renderTemplate()} closeModal={this.closeModal} />;
    }
}